import {
  vDate,
  vObject,
  vOptional,
  type vOutput,
  vString,
} from '../validation/index.ts'

export const updateBidExpirationDto = vObject({
  local: vOptional(vString()),
  utc: vOptional(vDate()),
})
export type UpdateBidExpirationDto = vOutput<typeof updateBidExpirationDto>

export interface LoadBidExpiration {
  utc: Date
  local: string
}
